import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalAnnouncementBannerComponent } from './global-announcement-banner.component/global-announcement-banner.component';
import { SafeHtmlPipe } from '@iris/common/modules/pipes-common/pipes';

@NgModule({
  imports: [
    CommonModule,
    SafeHtmlPipe,
  ],
  declarations: [
    GlobalAnnouncementBannerComponent,
  ],
  exports: [
    GlobalAnnouncementBannerComponent,
  ],
})
export class GlobalAnnouncementBannerModule { }
